import type { IIndication } from '../../../../../../common/utils/ggzoEmblIndicationUtils';
import { FormInlineGroup, FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

interface IIndicationsForTypeProps {
    indications: IIndication[];
    label: string;
}

export function IndicationsForType(props: IIndicationsForTypeProps) {
    return (
        <HorizontalFormGroupRead>
            <FormLabel>{props.label}</FormLabel>
            <InputContainer>
                <FormParagraph>
                    {props.indications.map((indication, index) => (
                        <FormInlineGroup
                            key={index}
                            value={indication.item}
                        />
                    ))}
                </FormParagraph>
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}
